<template>
 <div>
   <div class="fixed_page" id="blurry">
     <div class="get-started">
       <div class="home-main">
         <div class="fixed_page">
           <div class="select_rank">
             <a style="cursor: pointer" :class="['per_skill', { 'selected_rank' : rankPerSkillActive }]"
                @click.prevent="rankPerSkillActive = true, changeTypeValue(null)">{{ getTranslations.home_leaderboard_your_rank_per_skill }}</a>
             <a v-if="!hidePrizeSectionEnabledAtLeaderBoard" style="cursor: pointer" :class="['per_skill', { 'selected_rank' : !rankPerSkillActive }]"
                @click.prevent="rankPerSkillActive = false, fetchData()">{{ getTranslations.home_leaderboard_your_rank_per_prizes }}</a>
           </div>

           <div v-if="rankPerSkillActive" class="per_skill_section">
             <div class="get_started_list_section lead_prizes_section">
               <div class="main_title"><h1>{{ getTranslations.home_leaderboard_skills }}</h1></div>
               <div class="filter filter_skill">
                 <a :class="['logic', { 'current' : skillOption === skills.LOGIC }]" style="cursor: pointer" @click.prevent="skillOption = skills.LOGIC, changeTypeValue(null)">{{ getTranslations.home_post_game_modal_logic }}</a>
                 <a :class="['memory', { 'current' : skillOption === skills.MEMORY }]" style="cursor: pointer" @click.prevent="skillOption = skills.MEMORY, changeTypeValue(null)">{{ getTranslations.home_post_game_modal_memory }}</a>
                 <a :class="['attention', { 'current' : skillOption === skills.ATTENTION }]" style="cursor: pointer" @click.prevent="skillOption = skills.ATTENTION, changeTypeValue(null)">{{ getTranslations.home_post_game_modal_attention }}</a>
               </div>
               <div class="filter_list filter_list_skill">
                 <div :class="['list_item', skillOption.toLowerCase()]">
                   <!-- list item -->
                   <div class="lead_prize_box">
                     <img v-if="skillOption === skills.LOGIC" src="static/images/games/leaderboard-category-icon-logic.svg" alt="">
                     <img v-else-if="skillOption === skills.MEMORY" src="static/images/games/leaderboard-category-icon-memory.svg" alt="">
                     <img v-else src="static/images/games/leaderboard-category-icon-attention.svg" alt="">
                     <h1 v-if="skillOption === skills.LOGIC">{{ getTranslations.home_gametype_logic }}</h1>
                     <h1 v-else-if="skillOption === skills.MEMORY">{{ getTranslations.home_gametype_memory }}</h1>
                     <h1 v-else>{{ getTranslations.home_gametype_attention }}</h1>
                     <p>{{ getTranslations.home_leaderboard_rank_per_prizes }}</p>
                   </div>
                   <!-- end list item -->
                 </div>
               </div>
             </div>
           </div>

           <div v-else class="per_prize_section">
             <div class="get_started_list_section lead_prizes_section">
               <div class="main_title">
                 <h1>{{ getTranslations.home_leaderboard_prizes }}</h1>
               </div>
               <div class="filter">
                 <a v-if="getAvailablePrizeTypes.indexOf('DAILY') !== -1" @click.prevent="changeTypeValue('DAILY')"
                    :class="['daily', (prizeInfo.type === 'DAILY') ? 'current' : '']"
                    data-target="daily" style="cursor:pointer">
                   {{ getTranslations.home_leaderboard_daily_title }}</a>
                 <a v-if="getAvailablePrizeTypes.indexOf('WEEKLY') !== -1" @click.prevent="changeTypeValue('WEEKLY')"
                    :class="['weekly', (prizeInfo.type === 'WEEKLY') ? 'current' : '']"
                    data-target="weekly" style="cursor:pointer">
                   {{ getTranslations.home_leaderboard_weekly_title }}</a>
                 <a v-if="getAvailablePrizeTypes.indexOf('MONTHLY') !== -1" @click.prevent="changeTypeValue('MONTHLY')"
                    :class="['monthly', (prizeInfo.type === 'MONTHLY') ? 'current' : '']"
                    data-target="monthly" style="cursor:pointer">
                   {{ getTranslations.home_leaderboard_monthly_title }}</a>
                 <a v-if="getAvailablePrizeTypes.indexOf('GRAND') !== -1" @click.prevent="changeTypeValue('GRAND')"
                    :class="['grand', (prizeInfo.type === 'GRAND') ? 'current' : '']"
                    data-target="grand" style="cursor:pointer">
                   {{ getTranslations.home_leaderboard_grand_title }}</a>
               </div>
               <div class="filter_list">
                 <div v-for="(type, key) in ['DAILY', 'WEEKLY', 'MONTHLY', 'GRAND']"
                      v-if="prizeInfo.type === type && dataReady"
                      :class="['tab-container__item', (prizeInfo.type === type) ? 'active' : '' ]"
                      :key="key">
                   <DateTab :type="prizeInfo.type"
                            :get-date-format="getDateFormat"
                            :prizes="infoByCategory[type].prizes"
                            @initCarousel="initCarousel">
                   </DateTab>
                 </div>
               </div>
             </div>
           </div>
           <div class="circle_background">
             <div :class="[!rankPerSkillActive ? 'per_prize_section' : 'per_skill_section']">
               <PrizeTab v-for="(day,index) in [0, 1, 2]"
                         v-if="!rankPerSkillActive && infoByCategory[prizeInfo.type].winners &&
                           infoByCategory[prizeInfo.type].rank &&
                           infoByCategory[prizeInfo.type].tabActive === day"
                         :day="infoByCategory[prizeInfo.type].tabActive"
                         :type="prizeInfo.type"
                         :winners="infoByCategory[prizeInfo.type].winners ? infoByCategory[prizeInfo.type].winners[day] : []"
                         :user-points="calculateUserPoints(infoByCategory[prizeInfo.type].winners ? infoByCategory[prizeInfo.type].winners[day] : [])"
                         :get-rank="infoByCategory[prizeInfo.type].rank ? infoByCategory[prizeInfo.type].rank[day] : []"
                         :updatePoints="updatePoints"
                         :refreshedDate="infoByCategory[prizeInfo.type].prizes[day] ? infoByCategory[prizeInfo.type].prizes[day].lastRefreshed: ''"
                         :get-date-format="getDateFormat"
                         :key="index">
               </PrizeTab>
               <PrizeTab v-if="rankPerSkillActive && infoByGameType.winners && infoByGameType.rank"
                         :day="1"
                         :type="'gameType'"
                         :user-points="calculateUserPoints(infoByGameType.winners ? infoByGameType.winners : [])"
                         :winners="infoByGameType.winners ? infoByGameType.winners : []"
                         :get-rank="infoByGameType.rank ? infoByGameType.rank : []"
                         :updatePoints="updatePoints"
                         :refreshedDate="''"
                         :get-date-format="getDateFormat">
               </PrizeTab>
             </div>
           </div>
         </div>
     </div>
   </div>
 </div>
 </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import { GameTypesEnums } from '@/common/mixins/game';
import PrizeTab from './PrizeTab';
import DateTab from './DateTab';

export default {
  name: 'prizes-and-leaderboards',
  components: {
    DateTab,
    PrizeTab,
  },
  data() {
    return {
      dataReady: false, // due to network limitations we must ensure that carousel items will always be displayed correctly
      skills: null,
      skillOption: 'LOGIC',
      rankPerSkillActive: true,
      availableTypes: [],
      prizeInfo: {
        type: 'DAILY',
      },
      infoByCategory: {
        DAILY: {
          winners: [[], [], []],
          prizes: [{}, {}, {}],
          tabActive: 2, // 2 for today, 1 for one day ago , 0 for two days ago
          rank: [{}, {}, {}],
        },
        WEEKLY: {
          winners: [[], [], []],
          prizes: [{}, {}, {}],
          tabActive: 2,
          rank: [{}, {}, {}],
        },
        MONTHLY: {
          winners: [[], [], []],
          prizes: [{}, {}, {}],
          tabActive: 2,
          rank: [{}, {}, {}],
        },
        GRAND: {
          winners: [[], [], []],
          prizes: [{}, {}, {}],
          tabActive: 2,
          rank: [{}, {}, {}],
        },
      },
      infoByGameType: {
        winners: [],
        rank: {},
      },
    };
  },
  created() {
    this.skills = GameTypesEnums;
    this.fetchData();
  },
  methods: {
    ...mapActions('profile', [
      'storePrizesAndWinners',
      'storeAvailablePrizeTypes',
    ]),
    calculateUserPoints(array) {
      if (array.length === 0) return 0;
      return array.filter(winner => winner.msisdn === this.userDetails.msisdn)[0].points;
    },
    updatePoints() {
      this.storeAvailablePrizeTypes(localStorage.getItem('locale')).then(() => {
        this.fetchData();
      });
    },
    initCarousel() {
      const self = this;
      this.$nextTick(() => {
        /* eslint-disable */
        $('.owl-carousel').owlCarousel({
          loop: false,
          responsiveClass: true,
          dots: true,
          navContainer: '.carousel__nav',
          dotsContainer: '.prizes__carousel__dots',
          navText: ['<i class=\'icon-arrow-left\'></i>', '<i class=\'icon-arrow-right\'></i>'],
          responsive: {
            0: {
              items: 1,
              nav: true,
              onInitialized: function() {
                $(".icon-arrow-left").addClass("deactivated");
              },
              onTranslated: function(event){
                $('.icon-arrow-right').removeClass('deactivated');
                $('.icon-arrow-left').removeClass('deactivated');
                if (event.item.index === 0){
                  $(".icon-arrow-left").addClass("deactivated");
                } else {
                  $(".icon-arrow-left").show();
                }
                if (event.item.index === (event.item.count - 1)){
                  $(".icon-arrow-right").addClass("deactivated");
                }
                else {
                  $(".icon-arrow-right").show();
                }
              }
            },
          },
        }).on('changed.owl.carousel', function(event) {
          let currentTab = Math.abs(event.page.index - (event.relatedTarget._clones.length / 2));
          self.changeDay(currentTab);
        }).on('click', '.item', function () {
          self.clickOnImage(self.infoByCategory[self.prizeInfo.type].prizes[self.infoByCategory[self.prizeInfo.type].tabActive]);
        }).trigger('to.owl.carousel', self.infoByCategory[self.prizeInfo.type].tabActive - (3 - self.getNumOfPrizesPerType(self.prizeInfo.type)));
      });
      /* eslint-enable */
    },
    setGamesInfo() {
      this.infoByGameType.winners = this.getGameTypeWinnersForLeaderboard;
      this.infoByGameType.rank = this.getGameTypeRankForLeaderboard;
    },
    setCategoryInfo() {
      if (this.prizeInfo.type === 'DAILY') {
        this.infoByCategory[this.prizeInfo.type].winners = this.getDailyWinnersForLeaderboard;
        this.infoByCategory[this.prizeInfo.type].prizes = this.getDailyPrizeForLeaderboard;
        this.infoByCategory[this.prizeInfo.type].rank = this.getDailyRankForLeaderboard;
      } else if (this.prizeInfo.type === 'WEEKLY') {
        this.infoByCategory[this.prizeInfo.type].winners = this.getWeeklyWinnersForLeaderboard;
        this.infoByCategory[this.prizeInfo.type].prizes = this.getWeeklyPrizeForLeaderboard;
        this.infoByCategory[this.prizeInfo.type].rank = this.getWeeklyRankForLeaderboard;
      } else if (this.prizeInfo.type === 'MONTHLY') {
        this.infoByCategory[this.prizeInfo.type].winners = this.getMonthlyWinnersForLeaderboard;
        this.infoByCategory[this.prizeInfo.type].prizes = this.getMonthlyPrizeForLeaderboard;
        this.infoByCategory[this.prizeInfo.type].rank = this.getMonthlyRankForLeaderboard;
      } else if (this.prizeInfo.type === 'GRAND') {
        this.infoByCategory[this.prizeInfo.type].winners = this.getGrandWinnersForLeaderboard;
        this.infoByCategory[this.prizeInfo.type].prizes = this.getGrandPrizeForLeaderboard;
        this.infoByCategory[this.prizeInfo.type].rank = this.getGrandRankForLeaderboard;
      }
    },
    changeTypeValue(type) {
      this.dataReady = false;
      if (type) this.prizeInfo.type = type;
      const userData = {
        language: this.getLocale,
        prizeType: !type ? null : this.prizeInfo.type,
        gameType: !this.rankPerSkillActive ? null : this.skillOption,
      };
      this.storePrizesAndWinners(userData).then(() => {
        if (!type) this.setGamesInfo();
        else this.setCategoryInfo();
        this.initCarousel();
        this.dataReady = true;
      });
    },
    initActiveTab() {
      if (this.getAvailablePrizeTypes.indexOf('DAILY') !== -1) {
        this.prizeInfo.type = 'DAILY';
      } else if (this.getAvailablePrizeTypes.indexOf('WEEKLY') !== -1) {
        this.prizeInfo.type = 'WEEKLY';
      } else if (this.getAvailablePrizeTypes.indexOf('MONTHLY') !== -1) {
        this.prizeInfo.type = 'MONTHLY';
      } else if (this.getAvailablePrizeTypes.indexOf('GRAND') !== -1) {
        this.prizeInfo.type = 'GRAND';
      }
    },
    getNumOfPrizesPerType(type) {
      return this.infoByCategory[type].prizes.filter(item => item.activeFrom).length;
    },
    changeDay(day) {
      const availablePrizesForType = this.getNumOfPrizesPerType(this.prizeInfo.type);
      this.infoByCategory[this.prizeInfo.type].tabActive = (3 - availablePrizesForType) + day;
    },
    fetchData() {
      this.dataReady = false;
      this.initActiveTab();
      const userData = {
        language: this.getLocale,
        prizeType: !this.rankPerSkillActive ? this.prizeInfo.type : null,
        gameType: !this.rankPerSkillActive ? null : this.skillOption,
      };
      this.storePrizesAndWinners(userData).then(() => {
        if (!this.rankPerSkillActive) this.setCategoryInfo();
        else this.setGamesInfo();
        this.initCarousel();
        this.dataReady = true;
      });
    },
    getDateFormat(date, format) {
      this.$moment.locale(this.getLocale.toLowerCase());
      return this.$moment(date).format(format);
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
      'hidePrizeSectionEnabledAtLeaderBoard',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getLocale',
    ]),
    ...mapGetters('profile', [
      'getGameTypeWinnersForLeaderboard',
      'getGameTypeRankForLeaderboard',
      'getDailyWinnersForLeaderboard',
      'getWeeklyWinnersForLeaderboard',
      'getMonthlyWinnersForLeaderboard',
      'getDailyPrizeForLeaderboard',
      'getWeeklyPrizeForLeaderboard',
      'getMonthlyPrizeForLeaderboard',
      'getGrandWinnersForLeaderboard',
      'getGrandRankForLeaderboard',
      'getDailyRankForLeaderboard',
      'getWeeklyRankForLeaderboard',
      'getMonthlyRankForLeaderboard',
      'getGrandPrizeForLeaderboard',
      'getAvailablePrizeTypes',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/prizesAndLeaderboards/PrizesAndLeaderboards.vue